import InfoAlert from "@components/statusIndicators/InfoAlert.component";
import { useState } from "react";

interface SnowflakeGrantScriptProps {
  role: string;
  database: string;
}

export default function SnowflakeGrantScript({ role, database }: SnowflakeGrantScriptProps) {
  const [databaseName, setDatabaseName] = useState("DATABASE_NAME");
  const [schemaName, setSchemaName] = useState("SCHEMA_NAME");


  return (
    <div className="p-3">
      <p>
        If you can't find the table you're looking for, it's likely because Pliable's snowflake role doesn't have access. 
        Try running these commands, replacing the database and schema names with the information for the specific table you want to connect.
      </p>
      
      <InfoAlert>
        <div>
          <strong>Hint: </strong> 
          Pliable automatically has access to all tables in the{" "}
          <code className="bg-gray-100 px-1 py-0.5 rounded text-sm">
            {database}
          </code>{" "}
          database.
        </div>
      </InfoAlert>

      {/* Input fields */}
      <div className="mb-4">
        <div className="form-group mb-3">
          <label htmlFor="database-input" className="form-label">
            Database:
          </label>
          <input
            id="database-input"
            type="text"
            value={databaseName}
            onChange={(e) => setDatabaseName(e.target.value)}
            placeholder="Enter database name"
            className="form-control"
          />
        </div>
        
        <div className="form-group mb-3">
          <label htmlFor="schema-input" className="form-label">
            Schema:
          </label>
          <input
            id="schema-input"
            type="text"
            value={schemaName}
            onChange={(e) => setSchemaName(e.target.value)}
            placeholder="Enter schema name"
            className="form-control"
          />
        </div>
      </div>
      <hr className="my-3" />
      <p>Run the following script in your Snowflake account:</p>

        <div className="space-y-2">
          <p>
            <code className="bg-gray-100 px-2 py-1 rounded text-sm block">
              GRANT USAGE ON DATABASE {databaseName} TO ROLE {role};
            </code>
          </p>
          
          <p>
            <code className="bg-gray-100 px-2 py-1 rounded text-sm block">
              GRANT USAGE ON SCHEMA {databaseName || "DATABASE_NAME"}.{schemaName || "SCHEMA_NAME"} TO ROLE {role};
            </code>
          </p>
          
          <p>
            <code className="bg-gray-100 px-2 py-1 rounded text-sm block">
              GRANT SELECT ON ALL TABLES IN SCHEMA {databaseName || "DATABASE_NAME"}.{schemaName || "SCHEMA_NAME"} TO ROLE {role};
            </code>
          </p>
        </div>
    </div>
  );
}